// extracted by mini-css-extract-plugin
module.exports = {"glossary":"style_glossary__3GeXm"};